import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { ChapterSection } from "@/components/ChapterSection";

export default function Chapters() {
  return (
    <div>
      <Navbar />
      <PageHero
        kicker="Nationwide Network"
        title={<><span className="text-[#D90429]">Chapters</span></>}
        subtitle="Find the patriots standing watch in your community — or answer the call and start a chapter where one is needed."
      />
      <ChapterSection />
      <Footer />
    </div>
  );
}
